
import Paginate from './Paginate/Paginate';
import Table from './Table';
import Preloader from './Preloader/Preloader.jsx';
import Preloader2 from './Preloader/Preloader2.jsx';
import InputAutocomplete from './InputAutocomplete/InputAutocomplete';


export {
  Paginate, Table, Preloader, Preloader2, InputAutocomplete
};



// WEBPACK FOOTER //
// ./src/views/Plugins/index.js